if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // === VARIANTEN-UMLEITUNG MIT MENGEN-ANPASSUNG ===
const variantMapping = {
  // PRODUKT 1: ease-c grau
  '53184197001547': { target: '53184197001547', quantity: 1 },
  '53348797645131': { target: '53184197001547', quantity: 6 },
  '53184196968779': { target: '53184197001547', quantity: 3 },
  '53348797677899': { target: '53184197001547', quantity: 12 },
  
  // PRODUKT 2: ease-c weiss
  '53184172523851': { target: '53184172523851', quantity: 1 },
  '53348800790859': { target: '53184172523851', quantity: 6 },
  '53184172491083': { target: '53184172523851', quantity: 3 },
  '53348800823627': { target: '53184172523851', quantity: 12 },
  
  // PRODUKT 3: ease-c braun
  '53184129663307': { target: '53184129663307', quantity: 1 },
  '53262870774091': { target: '53184129663307', quantity: 6 },
  '53184129630539': { target: '53184129663307', quantity: 3 },
  '53262870806859': { target: '53184129663307', quantity: 12 },
  
  // PRODUKT 4: ease-c schwarz
  '53182772248907': { target: '53182772248907', quantity: 1 },
  '53348236591435': { target: '53182772248907', quantity: 6 },
  '53182772216139': { target: '53182772248907', quantity: 3 },
  '53348236624203': { target: '53182772248907', quantity: 12 }
};
        
        const currentVariantId = formData.get('id');
        const mapping = variantMapping[currentVariantId];
        
        if (mapping) {
          formData.set('id', mapping.target);
          formData.set('quantity', mapping.quantity);
          console.log(`✓ FormData geändert: ${currentVariantId} → ${mapping.target} (${mapping.quantity}x)`);
        }
        // === ENDE VARIANTEN-UMLEITUNG ===
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


if (!customElements.get('shipping-modal')) {
  customElements.define(
  'shipping-modal',
  class extends HTMLElement {
      constructor() {
      super();
      this.modal = this.querySelector('.js-modal');
      this.openButton = this.querySelector('.js-open');
      this.closeButton = this.querySelector('.js-close');

      this.openButton.addEventListener('click', () => this.openModal());
      this.closeButton.addEventListener('click', () => this.closeModal());
      window.addEventListener('click', (event) => {
          if (event.target === this.modal) {
          this.closeModal();
          }
      });
      }

      openModal() {
      this.modal.style.display = 'block';
      }

      closeModal() {
      this.modal.style.display = 'none';
      }
  }
  );
}